import Dexie, { type EntityTable } from 'dexie'

export interface LocalMedia {
  id: string
  blob: Blob
  createdAt: string
  name: string
  type: string
}

export interface LocalEvent {
  id?: number
  name: string
  at: string
  payload: Record<string, unknown>
}

class LoopDatabase extends Dexie {
  media!: EntityTable<LocalMedia, 'id'>
  events!: EntityTable<LocalEvent, 'id'>

  constructor() {
    super('loop6-demo')
    this.version(1).stores({ media: 'id,createdAt,type', events: '++id,name,at' })
  }
}

export const db = new LoopDatabase()

export async function saveLocalMedia(file: Blob, name = 'local-loop'): Promise<string> {
  const id = crypto.randomUUID()
  await db.media.put({ id, blob: file, createdAt: new Date().toISOString(), name, type: file.type })
  return id
}

export async function resolveMediaUrl(url: string): Promise<{ url: string; revoke: boolean }> {
  if (!url.startsWith('idb://')) return { url, revoke: false }
  const record = await db.media.get(url.slice(6))
  if (!record) throw new Error('This locally saved video is no longer available on this device.')
  return { url: URL.createObjectURL(record.blob), revoke: true }
}
